import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  // Store reference so the same function can be removed in disconnect()
  private timezoneHandler: ((event: Event) => void) | null = null;

  connect() {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    this.timezoneHandler = (event: Event) => {
      const { fetchOptions } = (event as CustomEvent).detail;
      fetchOptions.headers["X-Timezone"] = timezone;
    };

    document.addEventListener("turbo:before-fetch-request", this.timezoneHandler);
  }

  disconnect() {
    if (this.timezoneHandler) {
      document.removeEventListener("turbo:before-fetch-request", this.timezoneHandler);
      this.timezoneHandler = null;
    }
  }
}
